import { render, staticRenderFns } from "./DeleteTeamFromTournament.vue?vue&type=template&id=ed5135d0&scoped=true"
import script from "./DeleteTeamFromTournament.vue?vue&type=script&lang=js"
export * from "./DeleteTeamFromTournament.vue?vue&type=script&lang=js"
import style0 from "./DeleteTeamFromTournament.vue?vue&type=style&index=0&id=ed5135d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5135d0",
  null
  
)

export default component.exports